import zacharyPic from "@/public/images/artists/zachary.jpeg";
import { Artist } from "@/types/types";

export const zachary = {
  id: "117",
  name: "Zachary",
  image: zacharyPic,
  description: `Zachary's rap style combines intricate wordplay with a dynamic vocal delivery. His voice is characterized by sharp lyricism, rapid-fire rhythms, and a tone that seamlessly blends raw intensity with melodic hooks.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fzachary-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Hip Hop"],
      secondary: ["Youthful"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Mid",
      },
      specific: {
        low: 52,
        high: 71,
      },
    },
  },
} as const satisfies Artist;
